import { Button, FormControl, FormHelperText, FormLabel, Icon, Select, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { AuthorityActivity } from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { useSaveOrganization } from "../useOrganizationEditor";

interface FormValues {
  authorityActivity: AuthorityActivity | "";
}

interface Props {
  currentValue: AuthorityActivity | null;
}

export const ChangeAuthorityActivity = ({ currentValue }: Props) => {
  const { saveOrganization, isSaving } = useSaveOrganization();
  const toast = useToast();
  const { t } = useTranslation();
  const displayer = useApiError();
  const { register, handleSubmit, watch } = useForm<FormValues>({
    defaultValues: { authorityActivity: currentValue ?? "" },
  });

  const selected = watch("authorityActivity");

  const onSubmit = async (values: FormValues) => {
    try {
      await saveOrganization({ authorityActivity: { value: values.authorityActivity || null } });
      toast({ title: t("Main activity has been updated!"), status: "success" });
    } catch (e) {
      displayer.trigger(e);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl id="authorityActivity" mt="20px">
        <FormLabel>{t("Main activity")}</FormLabel>
        <Select placeholder={t("Select your main activity") ?? ""} {...register("authorityActivity")}>
          {Object.values(AuthorityActivity).map((activity) => (
            <option key={activity} value={activity}>
              {t(activity)}
            </option>
          ))}
        </Select>
        <FormHelperText>
          {t(
            "Stated on your notices on Doffin. Without a choice, the notices say general public services",
          )}
        </FormHelperText>
      </FormControl>
      {(currentValue ?? "") !== selected && (
        <Button
          mt="10px"
          leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
          variant="solid"
          colorScheme="teal"
          size="sm"
          type="submit"
          isLoading={isSaving}
        >
          {t("Save change")}
        </Button>
      )}
    </form>
  );
};
